export default __webpack_public_path__ + "static/media/icon-dollar.b87c965b.svg";